import { UPDATE_BRAND } from '../../endpoints';
import { IBrand } from '../../types/brand';
import makeAuthenticatedRequest from '../base-api';

interface UpdateBrandResponse {
  success: boolean;
  message?: string;
  brand?: IBrand;
}

const updateBrandApi = async (
  payload: IBrand
): Promise<UpdateBrandResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_BRAND, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update brand failed:', error);
    throw error;
  }
};

export { updateBrandApi, type UpdateBrandResponse };